function getCookie(name: string) {
    var start = document.cookie.indexOf(name + '=');
    var len = start + name.length + 1;
    if (!start && name != document.cookie.substring(0, name.length)) {
        return null;
    }
    if (start == -1) return null;
    var end = document.cookie.indexOf(';', len);
    if (end == -1) end = document.cookie.length;
    return unescape(document.cookie.substring(len, end));
}

function setCookie(name: string, value: string, expires: number) {
    var today = new Date();
    today.setTime(today.getTime());
    if (expires) {
        expires = expires * 1000 * 60 * 60 * 24;
    }
    var expires_date = new Date(today.getTime() + expires);
    document.cookie = name + '=' + escape(value) + (expires ? ';expires=' + expires_date.toGMTString() : '') + '; path=/'; //expires.toGMTString()
}

function delCookie(name: string) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(name);
    if (cval != null) document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString();
}
function debounce<T>(fn: (data: T) => any, wait: number) {
    var timeout: NodeJS.Timer | null | number = null;
    return function(data: T) {
        if (timeout !== null) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(() => {
            fn(data);
        }, wait);
    };
}
function getQuery(paraName: string) {
    var url = document.location.toString().replace('/#', '');
    var arrObj = url.split('?');

    if (arrObj.length > 1) {
        var arrPara = arrObj[1].split('&');
        var arr;

        for (var i = 0; i < arrPara.length; i++) {
            arr = arrPara[i].split('=');

            if (arr != null && arr[0] == paraName) {
                return arr[1];
            }
        }
        return '';
    } else {
        return '';
    }
}
function formatDate(date) {
    const newDate = typeof date == 'string' ? new Date(date) : date;
    let y = newDate.getFullYear();
    let m = newDate.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    let d = newDate.getDate();
    d = d < 10 ? '0' + d : d;
    return y + '-' + m + '-' + d;
}
var deepClone = function f(obj) {
    if (obj === null) return null;
    if (typeof obj !== 'object') return obj;
    if (obj.constructor === Date) return new Date(obj);
    if (obj.constructor === RegExp) return new RegExp(obj);
    var newObj = new obj.constructor(); //保持继承链
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            //不遍历其原型链上的属性
            var val = obj[key];
            newObj[key] = typeof val === 'object' ? f(val) : val; // 使用arguments.callee解除与函数名的耦合
        }
    }
    return newObj;
};
function getBeginEndStr(str: string, startStr: string, endStr: string) {
    const matchLength = str.match(eval('/' + startStr + '/g')).length;
    const attr = [];
    let fromIndex = 0;
    for (let i = 0; i < matchLength; i++) {
        let beginIndex = str.indexOf(startStr, fromIndex);
        let endIndex = str.indexOf(endStr, beginIndex);
        fromIndex = endIndex;
        attr.push(str.substring(beginIndex + startStr.length, endIndex));
    }
    return attr;
}
const isWechar = navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1;

/**
 * @description 通过筛选对象动态生成conditions
 * @param filter 筛选对象
 */
function getConditionsFromFilter(filters: ColumnObj[]) {
    let conditions: RequestConditions[] = [];
    filters.map((filter: ColumnObj) => {
        const {
            columnType,
            filterGroup: { filterType, filterContent },
            uuid
        } = filter;
        if (filterType != 'data-all') {
            switch (filter.columnType) {
                case 'DATE': {
                    filterContent.map((item: Date, index: number) => {
                        conditions.push({
                            chinese: filter.chinese,
                            queryType: index == 0 ? 'LARGEEQUAL' : 'LESSEQUAL',
                            requestValue: [formatDate(item)],
                            uuid
                        });
                    });
                    break;
                }
                case 'STRING': {
                    enum stringTypeMap {
                        'data-in' = 'IN',
                        'data-not-in' = 'NOTIN'
                    }
                    conditions.push({
                        chinese: filter.chinese,
                        queryType: stringTypeMap[filterType],
                        requestValue: filterContent,
                        uuid
                    });
                    break;
                }
                case 'HOUR': {
                    enum stringTypeMap {
                        'data-in' = 'IN',
                        'data-not-in' = 'NOTIN'
                    }
                    conditions.push({
                        chinese: filter.chinese,
                        queryType: stringTypeMap[filterType],
                        requestValue: filterContent,
                        uuid
                    });
                    break;
                }
                case 'NUMBER': {
                    enum numTypeMap {
                        'data-large' = 'LARGE',
                        'data-less' = 'LESS',
                        'data-less-equal' = 'LESSEQUAL',
                        'data-large-equal' = 'LARGEEQUAL',
                        'data-equal' = 'EQUAL',
                        'data-not-equal' = 'NOTEQUAL'
                    }
                    filterType != 'data-area'
                        ? conditions.push({
                              chinese: filter.chinese,
                              queryType: numTypeMap[filterType],
                              requestValue: filterContent,
                              uuid
                          })
                        : conditions.push(
                              {
                                  chinese: filter.chinese,
                                  queryType: numTypeMap['data-large'],
                                  requestValue: [filterContent[0]],
                                  uuid
                              },
                              {
                                  chinese: filter.chinese,
                                  queryType: numTypeMap['data-less-equal'],
                                  requestValue: [filterContent[1]],
                                  uuid
                              }
                          );
                    break;
                }
            }
        }
    });
    return conditions;
}
function formatThousandMark(value) {
    let curValue = String(value).replace(/\$|\%/g, '');

    const fuValue = String(value).indexOf('-') == 0;
    const dollarIndex = String(value).includes('$');
    const percentIndex = String(value).includes('%');
    if (Number(curValue)) {
        if (fuValue) {
            curValue = curValue.substring(1, 1000);
        }
        const str = String(curValue);
        if (Number(curValue) >= 1000) {
            let intLength = str.indexOf('.') != -1 ? str.indexOf('.') : str.length;
            let deciStr = str.substring(intLength, 1000);
            let attrReverse = str
                .split('')
                .slice(0, intLength)
                .reverse();
            for (let i = attrReverse.length - 2; i >= 0; i--) {
                if ((i + 1) % 3 === 0) {
                    attrReverse.splice(i + 1, 0, ',');
                }
            }
            return dollarIndex ? '$' + attrReverse.reverse().join('') + deciStr : percentIndex ? attrReverse.reverse().join('') + deciStr + '%' : fuValue ? '-' + attrReverse.reverse().join('') + deciStr : attrReverse.reverse().join('') + deciStr;
            // while()
        } else {
            return value;
        }
    } else {
        return value;
    }
}
function formatMonth(date: string) {
    const newDate = new Date(date);
    let y = newDate.getFullYear();
    let m = newDate.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    let d = newDate.getDate();
    d = d < 10 ? '0' + d : d;
    return y + '-' + m;
}
export { getCookie, setCookie, delCookie, debounce, getQuery, formatDate, deepClone, getBeginEndStr, isWechar, getConditionsFromFilter, formatThousandMark, formatMonth };
